import { NgModule } from '@angular/core';
import { MatTabsModule } from '@angular/material/tabs';
import { RouterModule } from '@angular/router';

import { FuseSidebarModule } from '@fuse/components';
import { FuseSharedModule } from '@fuse/shared.module';

import { ContentModule } from 'app/layout/components/content/content.module';
import { FooterModule } from 'app/layout/components/footer/footer.module';
import { NavbarModule } from 'app/layout/components/navbar/navbar.module';
import { QuickPanelModule } from 'app/layout/components/quick-panel/quick-panel.module';
import { TabContentModule } from 'app/layout/components/tab-content/tab-content.module';
import { ToolbarModule } from 'app/layout/components/toolbar/toolbar.module';

import { NotificationBarComponent } from 'app/layout/components/notification-bar/notification-bar.component';

@NgModule({
    declarations: [
        NotificationBarComponent
    ],
    imports     : [
        RouterModule,

        FuseSharedModule,
        FuseSidebarModule,

        ContentModule,
        TabContentModule,
        FooterModule,
        NavbarModule,
        QuickPanelModule,
        ToolbarModule,

        MatTabsModule
    ],
    exports     : [
        NotificationBarComponent
    ]
})
export class NotificationBarModule
{
}
